import React, { useContext, useEffect, useMemo } from "react";
import { CommonService } from "../../services/common/common.service";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext } from "../../store";

import { useTranslation } from "react-i18next";
import { ContentLayout } from "../../layouts/content/content.layout";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";
import SupportBlockComponent from "../../components/support/support.component";
import CoursesContentComponent from "../../modules/educations/components/courses/courses-content/courses-content.component";

const CoursesPage = () => {
  const { t } = useTranslation();
  const commonService = useMemo(() => new CommonService(), []);
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    const title = t("PAGE_META_TITLES.EDUCATION");
    commonService.setTitle(title);
    setPageTitle(title);
  }, [t, setPageTitle, commonService]);

  return (
    <>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.COURSES_TITLE")}
          subTitle={t("PAGES_HEAD.COURSES_SUB_TITLE")}
        />
        <CoursesContentComponent />
        <SupportBlockComponent />
      </ContentLayout>
    </>
  );
};
export default CoursesPage;
